module.exports = __webpack_public_path__ + "media/phone-090375bc.webp";